import * as messageService from "../../services/message.service";
import * as dashboardAdminService from '../../services/dashboardAdmin.service';

const state = {
    dAdminRecordType:'quotes',
    dAdminPeriodMode:'this-month',
    dAdminIsDashboardLoading:false,
    dAdminAllQuoteStatus:{},
    dAdminAllLeadsStatus:{},
    dAdminIsAllStatusLoading:false,



    dashboardAdminData:[],
    dAdminThisMonthData:[],
    dAdminLastMonthData:[],
    dAdminLastYearData:[],


    dAdminThisMonthLeadsData:[],
    dAdminLastMonthLeadsData:[],
    dAdminLastYearLeadsData:[],
};

const getters = {
    getDAdminRecordType:state => (state.dAdminRecordType),
    getDAdminPeriodMode:state => (state.dAdminPeriodMode),
    getDAdminIsDashboardLoading:state => (state.dAdminIsDashboardLoading),
    getDAdminAllQuoteStatus:state => (state.dAdminAllQuoteStatus),
    getDAdminAllLeadsStatus:state => (state.dAdminAllLeadsStatus),
    getDAdminIsAllStatusLoading:state => (state.dAdminIsAllStatusLoading),

    getDAdminThisMonthData:state => (state.dAdminThisMonthData),
    getDAdminLastMonthData:state => (state.dAdminLastMonthData),
    getDAdminLastYearData:state => (state.dAdminLastYearData),

    getDAdminThisMonthLeadsData:state => (state.dAdminThisMonthLeadsData),
    getDAdminLastMonthLeadsData:state => (state.dAdminLastMonthLeadsData),
    getDAdminLastYearLeadsData:state => (state.dAdminLastYearLeadsData),
};

const actions = {
    fetchDAdminRecordType({ commit }, recordType ){
      commit('setDAdminRecordType', recordType);
    },
    fetchDAdminPeriodMode({ commit }, periodMode ){
      commit('setDAdminPeriodMode', periodMode);
    },

    async fetchDashboardAdminData({ commit } ){
        try {
            const response = await dashboardAdminService.all();
            commit('setDashboardAdminData', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchDAdminThisMonthData({ commit }, obj){
        try {
          commit('setDAdminIsDashboardLoading', true);
          const response = await dashboardAdminService.thisMonth(obj);
          commit('setDAdminThisMonthData', response.data);
          commit('setDAdminIsDashboardLoading', false);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
            commit('setDAdminIsDashboardLoading', false);
        }
    },
    async fetchDAdminLastMonthData({ commit }, obj ){
        try {
          commit('setDAdminIsDashboardLoading', true);
          const response = await dashboardAdminService.lastMonth(obj);
          commit('setDAdminLastMonthData', response.data);
          commit('setDAdminIsDashboardLoading', false);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
            commit('setDAdminIsDashboardLoading', false);
        }
    },
    async fetchDAdminLastYearData({ commit }, obj ){
        try {
          commit('setDAdminIsDashboardLoading', true);
          const response = await dashboardAdminService.lastYear(obj);
          commit('setDAdminLastYearData', response.data);
          commit('setDAdminIsDashboardLoading', false);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
            commit('setDAdminIsDashboardLoading', false);
        }
    },
    async fetchDAdminAllQuoteStatusData({ commit }, obj ){
      try {
        commit('setDAdminIsAllStatusLoading', true);
        const response = await dashboardAdminService.allQuoteStatus(obj);
        commit('setDAdminAllQuoteStatus', response.data);
        commit('setDAdminIsAllStatusLoading', false);
      } catch (error) {
          const obj = {
              "type":'error',
              "title":error.response.data.error.name,
              "text":error.response.data.error.message,
              "footer":'Error code: ' + error.response.data.error.statusCode,
          }

          messageService.fnSweetAlertDisplay(obj);
          commit('setDAdminIsAllStatusLoading', false);
      }
    },
    async fetchDAdminAllLeadsStatusData({ commit }, obj ){
      try {
        commit('setDAdminIsAllStatusLoading', true);
        const response = await dashboardAdminService.allLeadsStatus(obj);
        commit('setDAdminAllLeadsStatus', response.data);
        commit('setDAdminIsAllStatusLoading', false);
      } catch (error) {
          const obj = {
              "type":'error',
              "title":error.response.data.error.name,
              "text":error.response.data.error.message,
              "footer":'Error code: ' + error.response.data.error.statusCode,
          }

          messageService.fnSweetAlertDisplay(obj);
          commit('setDAdminIsAlLeadsStatusLoading', false);
      }
    },

    async fetchDAdminThisMonthLeadsData({ commit }, obj){
      try {
        commit('setDAdminIsDashboardLoading', true);
        const response = await dashboardAdminService.thisMonthLeads(obj);
        commit('setDAdminThisMonthLeadsData', response.data);
        commit('setDAdminIsDashboardLoading', false);
      } catch (error) {
          const obj = {
              "type":'error',
              "title":error.response.data.error.name,
              "text":error.response.data.error.message,
              "footer":'Error code: ' + error.response.data.error.statusCode,
          }

          messageService.fnSweetAlertDisplay(obj);
          commit('setDAdminIsDashboardLoading', false);
      }
    },
    async fetchDAdminLastMonthLeadsData({ commit }, obj ){
      try {
        commit('setDAdminIsDashboardLoading', true);
        const response = await dashboardAdminService.lastMonthLeads(obj);
        commit('setDAdminLastMonthLeadsData', response.data);
        commit('setDAdminIsDashboardLoading', false);
      } catch (error) {
          const obj = {
              "type":'error',
              "title":error.response.data.error.name,
              "text":error.response.data.error.message,
              "footer":'Error code: ' + error.response.data.error.statusCode,
          }

          messageService.fnSweetAlertDisplay(obj);
          commit('setDAdminIsDashboardLoading', false);
      }
    },
    async fetchDAdminLastYearLeadsData({ commit }, obj ){
      try {
        commit('setDAdminIsDashboardLoading', true);
        const response = await dashboardAdminService.lastYearLeads(obj);
        commit('setDAdminLastYearLeadsData', response.data);
        commit('setDAdminIsDashboardLoading', false);
      } catch (error) {
          const obj = {
              "type":'error',
              "title":error.response.data.error.name,
              "text":error.response.data.error.message,
              "footer":'Error code: ' + error.response.data.error.statusCode,
          }

          messageService.fnSweetAlertDisplay(obj);
          commit('setDAdminIsDashboardLoading', false);
      }
    },

};

const mutations = {
    setDAdminRecordType:(state, res) => (
      state.dAdminRecordType = res
    ),
    setDAdminPeriodMode:(state, res) => (
      state.dAdminPeriodMode = res
    ),
    setDAdminIsDashboardLoading:(state, res) => (
      state.dAdminIsDashboardLoading =  res
    ),
    setDashboardAdminData:(state, res) => (
        state.dashboardAdminData =  res
    ),
    setDAdminThisMonthData:(state, res) => (
        state.dAdminThisMonthData =  res
    ),
    setDAdminLastMonthData:(state, res) => (
        state.dAdminLastMonthData =  res
    ),
    setDAdminLastYearData:(state, res) => (
        state.dAdminLastYearData =  res
    ),
    setDAdminAllQuoteStatus:(state, res) => (
      state.dAdminAllQuoteStatus =  res
    ),
    setDAdminAllLeadsStatus:(state, res) => (
      state.dAdminAllLeadsStatus =  res
    ),
    setDAdminIsAllStatusLoading:(state, res) => (
      state.dAdminIsAllStatusLoading = res
    ),
    setDAdminThisMonthLeadsData:(state, res) => (
      state.dAdminThisMonthLeadsData =  res
    ),
    setDAdminLastMonthLeadsData:(state, res) => (
      state.dAdminLastMonthLeadsData =  res
    ),
    setDAdminLastYearLeadsData:(state, res) => (
      state.dAdminLastYearLeadsData =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}
